// src/EventFilters.tsx
import React, { FC } from 'react';
import { FilterOption } from './models';

export interface EventFilterProps {
  name: string;
  options: FilterOption[];
  checkedValues: string[];
  onCheckedChange: (newValues: string[]) => void;
  label?: string;
  clearText?: string;
  allValue?: string;
}

export const EventFilters: FC<EventFilterProps> = ({
  name,
  options,
  checkedValues,
  onCheckedChange,
  label = '',
  clearText = 'All',
  allValue = 'all',
}) => {
  const toggleOption = (value: string) => {
    const normalized = value.toLowerCase();
    let next: string[];

    if (normalized === allValue) {
      next = [allValue];
    } else {
      next = checkedValues.filter(v => v !== allValue);
      if (next.includes(normalized)) {
        next = next.filter(v => v !== normalized);
      } else {
        next = [...next, normalized];
      }
      if (next.length === 0) next = [allValue];
    }

    onCheckedChange(next);
  };

  const clearAll = () => onCheckedChange([allValue]);

  return (
		<div className="event-btn-filter">
  {label && <div className="event-filter-label">{label}</div>}

  <div className="event-filter-buttons">
    <label
      className={
        `event-filter-item ` +
        (checkedValues.includes(allValue) ? 'selected' : '')
      }
    >
      <input
        type="checkbox"
        checked={checkedValues.includes(allValue)}
        onChange={() => toggleOption(allValue)}
      />
      <span className="event-filter-text">{clearText}</span>
    </label>

    {options.map(opt => {
      const val = opt.filterValue.toLowerCase();
      return (
        <label
          key={val}
          className={
            `event-filter-item ` +
            (checkedValues.includes(val) ? 'selected' : '')
          }
        >
          <input
            type="checkbox"
            checked={checkedValues.includes(val)}
            onChange={() => toggleOption(val)}
          />
          <span className="event-filter-text">
            {opt.filterDisplayValue}
          </span>
        </label>
      );
    })}
  </div>
</div>

	
  );
};
